import { useDispatch, useSelector } from "react-redux";
import { AppStore } from "../../../../redux/store";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import useCallApiAndLoad from "../../../../hooks/useCallApiAndLoad";
import { unsetAuth } from "../../../../helpers/authHelper";
import { fetchResponseAdapter } from "../../../../adapters/fetchAdapter";
import { logoutAction } from "../../../../redux/features/auth";
import {
  editProfileCustomer,
  getCustomerInfo,
  sendOTPCustomer,
  validateCustomerOTP,
} from "../../../../services/accountService";
import { CustomerData } from "../../../../models/authUserModel";

export const useCustomerProfile = () => {
  const user = useSelector((store: AppStore) => store.auth);
  const token = require("../../../../helpers/authHelper").getAuthToken(user);
  const { country } = useSelector((store: AppStore) => store.country);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [customerData, setCustomerData] = useState<CustomerData>();
  const [loadingCustomer, setLoadingCustomer] = useState(false);
  const { callEndpoint } = useCallApiAndLoad();

  const [errorMessage, setErrorMessage] = useState<boolean>(false);
  const [errorMessageText, setErrorMessageText] = useState<string>("");
  const [successMessage, setSuccessMessage] = useState<boolean>(false);
  const [successMessageText, setSuccessMessageText] = useState<string>("");

  const getCustomerInfoData = async () => {
    if (customerData) return; // Si ya hay datos, no consultar
    setLoadingCustomer(true);
    try {
      const { status, data } = await callEndpoint(getCustomerInfo(token));
      
      if (status === 401) {
        setLoadingCustomer(false);
        dispatch(logoutAction({}));
        unsetAuth();
        navigate(`/app/${country}/auth/login`);
      }
      if (status === 200) {
        const response = fetchResponseAdapter(data);
        setLoadingCustomer(false);
        setCustomerData(response.data);
         }
    } catch (error) {
      setLoadingCustomer(false);
      console.log(error);
    }
  };

  const editData = async (dataCustomer: any) => {
    const { status, data } = await callEndpoint(
      editProfileCustomer(dataCustomer, token)
    );
    if (status === 200) {
      setSuccessMessage(true);
      setSuccessMessageText("Perfil actualizado correctamente");
    } else {
      setErrorMessage(true);
      setErrorMessageText(data?.message);
    }
  };

  const editPhoneData = async (dataCustomer: any, onSuccess: () => void, provider: string) => {
    const { status, data } = await callEndpoint(
      editProfileCustomer(dataCustomer, token)
    );
    const dataOTP = { provider: provider };

    if (status === 200) {
      const { status: statusOtep, data: dataOtp } = await callEndpoint(sendOTPCustomer(dataOTP, token));
      if (statusOtep === 201) {
        onSuccess();
      }
    } else {
      setErrorMessage(true);
      setErrorMessageText(data?.message);
    }
  };

  //user/v1/customer/validate-otp

  const sendValidateOtp = async (codeData: any) => {
    const { status, data } = await callEndpoint(
      validateCustomerOTP(codeData, token)
    );
    if (status === 201) {
      setSuccessMessage(true);
      setSuccessMessageText("Número de teléfono verificado correctamente");
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    } else {
      setErrorMessage(true);
      setErrorMessageText(data?.message);
    }
  };

  const resendCustomerOtp = async (provider: string) => {
    const { status } = await callEndpoint(
      sendOTPCustomer({ provider: provider }, token)
    );
    if (status === 201) {
      setSuccessMessage(true);
      setSuccessMessageText("El código fue reenviado");
    } else {
      setErrorMessage(true);
      setErrorMessageText(
        "Lo sentimos el código no puede ser reenviado, intenta mas tarde"
      );
    }
  };
  return {
    customerData,
    loadingCustomer,
    getCustomerInfoData,
    sendValidateOtp,
    resendCustomerOtp,
    editData,
    errorMessage,
    errorMessageText,
    successMessageText,
    successMessage,
    editPhoneData,
  };
};
